<template>
    <v-container class="container" fluid>
        <v-form ref="form" v-model="valid" lazy-validation>
            <v-card class="mb-5">
                <v-toolbar dark color="secondary" dense>
                    <v-spacer></v-spacer>
                    <v-toolbar-title class="white--text"
                        >Fuel Statement</v-toolbar-title
                    >
                    <v-spacer></v-spacer>
                    <v-btn icon left to="/administration/fuel"
                        ><v-icon>mdi-arrow-left</v-icon></v-btn
                    >
                </v-toolbar>
                <v-row justify="center">
                    <v-col cols="2">
                        <v-text-field
                            label="Start Date"
                            id="StartDate"
                            v-model="startDate"
                            placeholder="yyyy-mm-dd"
                            v-mask="'####-##-##'"
                            :rules="dateRules"
                            required
                        ></v-text-field>
                    </v-col>
                    <v-col cols="2">
                        <v-text-field
                            label="End Date"
                            id="EndDate"
                            v-model="endDate"
                            placeholder="yyyy-mm-dd"
                            v-mask="'####-##-##'"
                            :rules="dateRules"
                            required
                        ></v-text-field>
                    </v-col>
                    <v-col cols="2">
                        <v-combobox
                            v-model="comboboxTrucks"
                            @change="validate()"
                            placeholder="Select truck"
                            :items="trucks"
                            :rules="[v => !!v || 'Required']"
                            required
                            :item-text="'Truck'"
                            :item-value="'TruckID'"
                            auto-select-first
                        ></v-combobox>
                    </v-col>
                    <v-col cols="2">
                        <v-combobox
                            v-model="payid"
                            placeholder="Select PayId"
                            label="PayId"
                            :items="payids"
                            required
                            :item-text="'PayStId'"
                            :item-value="'PayStId'"
                            auto-select-first
                        ></v-combobox>
                    </v-col>
                </v-row>
                <v-container grid-list-xs fluid>
                    <v-data-table
                        dense
                        :headers="headers"
                        :items="data"
                        class="elevation-1 tbl-fuel"
                        disable-sort
                        :show-first-last-page="false"
                        :show-current-page="false"
                        height="250px"
                        :items-per-page="-1"
                    >
                        <template v-slot:top>
                            <v-toolbar dark color="secondary" dense>
                                <v-spacer></v-spacer>
                                <v-toolbar-title class="white--text"
                                    >Fuel Statement Post &
                                    Posted</v-toolbar-title
                                >
                                <v-spacer></v-spacer>
                            </v-toolbar>
                        </template>
                        <template v-slot:footer.page-text>
                            <v-btn
                                color="primary"
                                dark
                                class="ma-2"
                                @click="savePostFuelSt"
                            >
                                Save Fuel Statement
                            </v-btn>
                        </template>
                        <template v-slot:item="{ item, index }">
                            <tr
                                :style="
                                    item.Post == 1 ? 'background:#ddd;' : ''
                                "
                            >
                                <td>{{ item.Stid }}</td>
                                <td>{{ item.Driver }}</td>
                                <td>{{ item.Type }}</td>
                                <td>{{ item.Date }}</td>
                                <td>{{ item.InvoiceNo }}</td>
                                <td>{{ item.Qty }}</td>
                                <td>{{ item.GST }}</td>
                                <td>{{ item.Total }}</td>
                                <td>{{ item.ActualPrice }}</td>
                                <td>{{ item.ActualCost }}</td>
                                <td>
                                    <v-icon
                                        v-if="item.Post == 0"
                                        class="mx-3"
                                        @click="deleteitem(item, index)"
                                        >mdi-arrow-down-circle</v-icon
                                    >
                                    <v-icon
                                        v-else
                                        class="mx-3"
                                        @click="unposted(item, index)"
                                        >mdi-broom</v-icon
                                    >
                                </td>
                            </tr>
                            <!-- <v-icon small @click="deleteItem(item)">mdi-delete</v-icon> -->
                        </template>
                    </v-data-table>
                    <br />
                    <v-data-table
                        dense
                        :headers="headers"
                        :items="down"
                        class="elevation-1"
                        hide-default-footer
                        disable-sort
                        disable-pagination
                        :items-per-page="-1"
                    >
                        <template v-slot:top>
                            <v-toolbar dark color="secondary" dense>
                                <v-spacer></v-spacer>
                                <v-toolbar-title class="white--text"
                                    >Fuel Statement UnPosted</v-toolbar-title
                                >
                                <v-spacer></v-spacer>
                            </v-toolbar>
                        </template>
                        <template v-slot:item.action="{ item, index }">
                            <v-icon
                                v-if="item.Post == 0"
                                class="mx-3"
                                @click="returnItem(item, index)"
                                >mdi-arrow-up-circle</v-icon
                            >
                            <v-icon
                                v-else
                                class="mx-3"
                                @click="returnItem(item, index)"
                                >mdi-broom</v-icon
                            >
                            <!-- <v-icon small @click="deleteItem(item)">mdi-delete</v-icon> -->
                        </template>
                    </v-data-table>
                </v-container>
            </v-card>
        </v-form>
    </v-container>
</template>

<script>
import axios from 'axios';
import { mask } from 'vue-the-mask';
export default {
    name: 'FuelStatement',
    directives: { mask },
    data: function() {
        return {
            valid: false,
            comboboxTrucks: '',
            trucks: [],
            startDate: '',
            endDate: '',
            stNumber: '',
            payid: null,
            payids: [],
            dateRules: [
                v =>
                    (parseInt(v[5] + v[6]) <= 12 &&
                        parseInt(v[5] + v[6]) > 0) ||
                    'Date Incorrect',
                v =>
                    (parseInt(v[8] + v[9]) <= 31 &&
                        parseInt(v[8] + v[9]) > 0) ||
                    'Date Incorrect',
                v => !!v || 'Required'
            ],
            data: [],
            StNum: '',
            headers: [
                { text: 'Stmt PayId', value: 'Stid' },
                { text: 'Driver', value: 'Driver' },
                { text: 'Type', value: 'Type' },
                { text: 'Date', value: 'Date' },
                { text: 'Invoice No.', value: 'InvoiceNo' },
                { text: 'QTY', value: 'Qty' },
                { text: 'GST', value: 'GST' },
                { text: 'Total', value: 'Total' },
                { text: 'Actual Price', value: 'ActualPrice' },
                { text: 'Actual Cost', value: 'ActualCost' },
                { text: 'Actions', value: 'action', width: '5%' }
            ],
            down: []
        };
    },
    mounted() {
        this.loadTrucks();
    },
    methods: {
        loadTrucks: function() {
            this.$store.state.isLoading = true;
            axios
                .get('truck/active', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log(response.data);
                    this.trucks = response.data;
                    this.$store.state.isLoading = false;
                })
                .catch(error => {
                    this.$store.state.isLoading = false;
                    console.log(error);
                });
        },
        loadPayIds: function() {
            this.payids = [];
            this.payid = [];
            if (
                this.$store.state.getMsk('StartDate') == '' ||
                this.$store.state.getMsk('EndDate') == '' ||
                this.$store.state.getMsk('StartDate') >
                    this.$store.state.getMsk('EndDate')
            ) {
                this.$store.dispatch('setSnackbar', {
                    color: 'error',
                    text: 'Enter correct dates'
                });
            } else {
                this.$store.state.isLoading = true;
                var parms = {
                    StartDate: this.$store.state.getMsk('StartDate'),
                    EndDate: this.$store.state.getMsk('EndDate'),
                    Truck: this.comboboxTrucks.TruckID
                };
                axios
                    .post('/fuel-expense/payId/range', parms, {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    })
                    .then(response => {
                        this.payids = response.data;
                        this.$store.state.isLoading = false;
                    })
                    .catch(error => {
                        this.$store.state.isLoading = false;
                        console.log(error);
                    });
            }
        },
        postFuelSt: function() {
            this.down = [];
            this.data = [];
            this.$store.state.isLoading = true;
            var params = {
                StartDate: this.$store.state.getMsk('StartDate'),
                EndDate: this.$store.state.getMsk('EndDate'),
                // Stid: this.payid.PayStId,
                Truck: this.comboboxTrucks.TruckID
            };
            console.log(params);
            axios
                .post('fuel-expense/statement', params, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    const data = response.data;
                    const exts = data.findIndex(x => {
                        return x.Post === 1;
                    });
                    if (exts >= 0) {
                        this.down = data.filter(x => {
                            return x.Post === 0;
                        });
                        this.data = data.filter(x => {
                            return x.Post === 1;
                        });
                    } else {
                        this.data = data;
                    }
                    console.log(this.data, this.down);
                    this.$store.state.isLoading = false;
                })
                .catch(error => {
                    this.$store.state.isLoading = false;
                    this.$store.dispatch('setSnackbar', {
                        color: 'error',
                        text: 'An error has ocurred, please try again.'
                    });
                    console.log(error);
                });
        },
        validate() {
            if (this.$refs.form.validate()) {
                this.loadPayIds();
                this.postFuelSt();
            }
        },
        Fixet: function() {
            this.data = this.$store.state.fuelStatement.data;
            this.data.forEach(element => {
                element.Qty = Number(element.Qty).toFixed(2);
                element.GSTTruckFuelStatement = Number(element.GST).toFixed(2);
                element.Total = Number(element.Total).toFixed(2);
            });
            console.log(this.data);
        },
        deleteitem: function(itm, index) {
            this.down.push(itm);
            this.data.splice(index, 1);
        },
        returnItem: function(itm, index) {
            this.data.push(itm);
            this.down.splice(index, 1);
        },
        unposted: function(itm, index) {
            var params = {
                Stid: null
            };
            console.log(params, itm);
            axios
                .put('fuel-expense/' + itm.OOExpId, params, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log(response.status);
                    this.$store.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Fuel UnPosted Successfully'
                    });

                    itm.Stid = null;
                    itm.Post = 0;
                    this.down.push(itm);
                    this.data.splice(index, 1);
                    // this.postFuelSt();
                    // this.$router.push('/Administration/fuel/fuel-statement');
                    this.$store.state.isLoading = false;
                })
                .catch(error => {
                    this.$store.state.isLoading = false;
                    this.$store.dispatch('setSnackbar', {
                        color: 'error',
                        text: 'An error has ocurred, please try again.'
                    });
                    console.log(error);
                });
        },
        printFuelExpenseReport: async function() {
            var str = this.$store;
            this.$store.state.isLoading = true;
            var parms = {
                stID: this.payid.PayStId,
                StSp: 1
            };
            axios
                .post('fuel-expense/statement-report', parms, {
                    responseType: 'blob',
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    const url = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute(
                        'download',
                        this.payid.PayStId + ' - Fuel.pdf'
                    );
                    document.body.appendChild(link);
                    link.click();
                    this.$router.push('/Administration/fuel/fuel-statement');

                    this.$store.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);

                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                    str.state.isLoading = false;
                });
        },
        savePostFuelSt: function() {
            // this.$store.state.isLoading = true;
            if (this.payid.length == 0 || this.payid === null) {
                this.$store.dispatch('setSnackbar', {
                    color: 'red',
                    text: 'Select a PayId'
                });
            } else {
                var params = {
                    Statement: this.data.filter(x => {
                        return x.Stid === null;
                    }),
                    StNum: this.payid.PayStId
                };
                console.log(params);
                axios
                    .post('fuel-expense/statement/confirm', params, {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    })
                    .then(response => {
                        console.log(response.status);
                        this.$store.state.fuelStatement = [];
                        this.$store.dispatch('setSnackbar', {
                            color: 'success',
                            text: 'Fuel Posted Successfully'
                        });
                        this.printFuelExpenseReport();
                        this.postFuelSt();
                        // this.$router.push('/Administration/fuel/fuel-statement');
                        this.$store.state.isLoading = false;
                    })
                    .catch(error => {
                        this.$store.state.isLoading = false;
                        this.$store.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                        console.log(error);
                    });
            }
        }
    }
};
</script>
<style></style>
